/*
 * @Date: 2022-08-23 11:46:39
 * @LastEditors: kinfai
 * @Description: 留言工具
 * @LastEditTime: 2022-08-23 17:05:52
 * @FilePath: \my-app\src\pages\LeaveMsg\index.jsx
 */
import "./index.less";
import BgHeader from "../../components/BgHeader";
import {useState, useContext, useMemo, useEffect} from "react";
import {LeftOutlined} from "@ant-design/icons";
import {RouteContext} from "../../provide/route-context";
import {Form, Button, Input, Result, Spin} from "antd";
import EasyUpload from "../../components/EasyUpload";
import leaveMsgApi from "../../axios/leaveMsg/index.js";
import useCs from "../../hooks/cs/index.js";
import frontEndApi from "../../hooks/frontEndApi/index.js";


export default function LeaveMsg() {
    const [isSuccess, setStatus] = useState(false);
    const {getCsId} = useCs()
    const context = useContext(RouteContext);

    const backName = useMemo(() => {
        return isSuccess ? "Back" : "Leave a message";
    }, [isSuccess]);

    const backUp = (value) => {
        const go = () => value.goPage("Home");

        return (
            <span className="g-back-route" onClick={go}>
        <LeftOutlined
            style={{
                marginRight: "7px",
                fontWeight: "bold",
                fontSize: "24px",
            }}
        />
                {backName}
      </span>
        );
    };

    const SubmitForm = () => {
        const [config, setConfig] = useState({
            name_status: 0,
            photo_status: 0,
            email_status: 0,
            desc_status: 0,
            phone_status: 0
        })
        const [form] = Form.useForm();
        const [errorTip, setErrorTip] = useState("")
        const [submitLoading, setSubmitLoading] = useState(false)
        const [init, setInit] = useState(false)

        const {TextArea} = Input;

        // 提交表单信息
        const onFinish = (values) => {
            setSubmitLoading(true)
            getCsId().then(csId => {
                const webpage = window.location.href

                leaveMsgApi.sendQuestLeaving({
                    ...values,
                    kefu_sfid: csId,
                    webpage
                }).then(res => {
                    if (res.code === 200) {
                        setStatus(true);
                    }
                }).catch(err => {
                    if (err.data.msg === 'The email must be a valid email address.') {
                        err.data.msg = "请输入正确的邮箱地址~"
                        console.log(form)
                    }
                    setErrorTip(err.data.msg)
                    form.setFieldValue("email", "")
                }).finally(() => {
                    setSubmitLoading(false)
                })
            })
        };

        //  请求表单配置
        let isInit = true
        useEffect(() => {
            const getConfig = async () => {
                let res = await leaveMsgApi.getRobotConfig().catch(err => err)
                // 412 - 没有设置聊天配置
                if (res.code === 412 || res.data === null) {
                    const leavingMobotInfoRes = await frontEndApi.leavingMobotInfo()
                    setConfig(leavingMobotInfoRes)
                } else {
                    setConfig(res.data)
                }

                setInit(true)
            }

            isInit && getConfig()

            return () => {
                isInit = false
            }
        }, [])

        // 表单配置
        const formConfig = [
            {
                visibleKey: 'name_status',
                name: 'name',
                rules: [
                    {
                        required: true,
                        message: "Please input your name!",
                    },
                ],
                Slot: () => <Input placeholder="*Name" showCount maxLength={30}/>
            },
            {
                visibleKey: 'email_status',
                name: 'email',
                rules: [
                    {
                        required: true,
                        message: "Please input your Email!",
                    },
                ],
                Slot: () => <Input placeholder="*Email" showCount maxLength={30}/>

            },
            {
                visibleKey: 'phone_status',
                name: 'phone',
                Slot: () => <Input placeholder="Phone Number" showCount maxLength={30}/>
            },
            {
                visibleKey: 'desc_status',
                name: 'contents',
                rules: [
                    {
                        required: true,
                        message: "Please input your Describe!",
                    },
                ],
                Slot: () => <TextArea
                    placeholder="*Describe"
                    rows={5}
                    showCount
                    maxLength={300}
                ></TextArea>
            },
            // {
            //     visibleKey: 'photo_status',
            //     name: 'photo',
            //     Slot: () => <EasyUpload/>
            // }
        ]

        if (!init) {
            return <Spin tip="loading..."/>
        }

        return (
            <Spin spinning={submitLoading}>
                <Form
                    onFinish={onFinish}
                    name="control-hooks"
                    form={form}
                    autoComplete="off"
                    size="large"
                >
                    {
                        formConfig.filter(row => config[row.visibleKey] === 1)
                            .map((row, index) => {
                                return <Form.Item key={index} name={row.name} rules={row.rules}>
                                    {row.Slot()}
                                </Form.Item>
                            })
                    }
                    {
                        errorTip && <p style={{
                            textAlign: 'left',
                            marginBottom: '8px',
                            color: 'red'
                        }}>提示:{
                            errorTip
                        }</p>
                    }
                    {
                        init &&
                        <Button type="primary" style={{width: "100%"}} htmlType="submit">
                            Submit
                        </Button>
                    }

                </Form>
            </Spin>
        );
    };

    return (
        <div>
            <BgHeader height="84px" subComponent={backUp(context)}></BgHeader>
            <div className="g-submit-form">
                {isSuccess ? <Result status="success" title="Submitted Successfully"></Result> : <SubmitForm/>}
            </div>
        </div>
    );
}
